'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import PreviewDevices from 'ContentComponents/components/preview/PreviewDevices';
import FullscreenModal from 'ContentComponents/components/modals/FullscreenModal';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { userInfoSync } from 'hub-http/userInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const getPreviewDevicesProps = contentType => {
  const {
    user
  } = userInfoSync();
  if (contentType !== 'email') {
    return {};
  }
  return {
    from: {
      email: user.email,
      name: formatName({
        firstName: user.first_name,
        lastName: user.last_name
      })
    },
    selectedContact: {
      email: I18n.text('ContentComponents.previewDevices.sampleRecipient.email'),
      name: I18n.text('ContentComponents.previewDevices.sampleRecipient.name')
    },
    subject: I18n.text('ContentComponents.previewDevices.sampleSubject')
  };
};
class PreviewFullscreenModal extends Component {
  render() {
    return /*#__PURE__*/_jsx(FullscreenModal, {
      headerButton: this.props.headerButton,
      headerContent: this.props.headerContent,
      onClose: this.props.handleClose,
      modalProps: this.props.modalProps,
      children: /*#__PURE__*/_jsx(PreviewDevices, Object.assign({}, getPreviewDevicesProps(this.props.contentType), this.props))
    });
  }
}
PreviewFullscreenModal.propTypes = {
  contentType: PropTypes.string.isRequired,
  headerButton: PropTypes.node,
  headerContent: PropTypes.node,
  handleClose: PropTypes.func.isRequired,
  previewUrl: PropTypes.string,
  leftArrowEnabled: PropTypes.bool,
  rightArrowEnabled: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  modalProps: PropTypes.object
};
export default PreviewFullscreenModal;